<div class="partner-area ptb-100 pt-0">
    <div class="container">
        <div class="section-title">
            <br/><br/>
            <h2 >Our Customers</h2>
        </div>
        <div class="partner-slides owl-carousel owl-theme">
            <div class="single-partner-item">
                <a href="#">
                    <img style="height: 50px;" src="assets/img/partner-image/perfectcabin.png" alt="Perfect Cabin">
                    <img src="assets/img/partner-image/perfectcabin.png" alt="Perfect Cabin">
                </a>
            </div>
            <div class="single-partner-item">
                <a href="#">
                    <img src="assets/img/partner-image/kjsdental.png" alt="KJS Dental Hospital">
                    <img src="assets/img/partner-image/kjsdental.png" alt="KJS Dental Hospital">
                </a>
            </div>
            <div class="single-partner-item">
                <a href="#">
                    <img src="assets/img/partner-image/Gogreen.jpg" alt="Gogreen Interiors">
                    <img src="assets/img/partner-image/Gogreen.jpg" alt="Gogreen Interiors">
                </a>
            </div>
            <div class="single-partner-item">
                <a href="#">
                    <img style="height: 50px;" src="assets/img/partner-image/srisaidental.jpeg" alt="Sri Sai Dental Hospital">
                    <img src="assets/img/partner-image/srisaidental.jpeg" alt="Sri Sai Dental Hospital">
                </a>
            </div>
            <div class="single-partner-item">
                <a href="#">
                    <img src="assets/img/partner-image/Ridhielite.jpg" alt="Ridhie Lite Studio">
                    <img src="assets/img/partner-image/Ridhielite.jpg" alt="Ridhie Lite Studio">
                </a>
            </div>
            <div class="single-partner-item">
                <a href="#">
                    <img src="assets/img/partner-image/partner1.png" alt="Dr Gowds Clinic">
                    <img src="assets/img/partner-image/partner1.png" alt="Dr Gowds Clinic">
                </a>
            </div>
            <div class="single-partner-item">
                <a href="#">
                    <img style="height: 50px;" src="assets/img/partner-image/kavithareddy.png" alt="Kavitha Reddy Hospital">
                    <img src="assets/img/partner-image/kavithareddy.png" alt="Kavitha Reddy Hospital">
                </a>
            </div>

           
          
        </div>
        <br/><br/>
    </div>
</div>